import CallToActionButton from '@/components/landingPage/CallToActionButton';

type BulletPoint = {
  title: string;
  body: string;
};
type FeelgoodWeightProps = {
  title?: string;
  buttonText?: string;
  bulletPoints?: BulletPoint[];
};
const DEFAULT_BULLET_POINTS: BulletPoint[] = [
  {
    title: 'Stressfrei',
    body: 'ohne Kalorienzählen, ohne Verbote, ohne Jo-Jo-Effekt',
  },
  {
    title: 'Alltagstauglich',
    body: 'egal ob im Beruf, Freizeit oder mit der Familie',
  },
  {
    title: 'Nachhaltig',
    body: 'neue Gewohnheiten rund um Ernährung und Bewegung schaffen',
  },
  {
    title: 'Kostenlos',
    body: 'Übernahme durch deine Krankenkasse',
  },
];

const FeelgoodWeight = ({
  title = 'Mit Oviva Schritt für Schritt zum Dauerwohlfühlgewicht',
  buttonText,
  bulletPoints = DEFAULT_BULLET_POINTS,
}: FeelgoodWeightProps) => {
  return (
    <div
      className="flyntComponent componentSpacing feelgood-weight-component"
      is="flynt-grid-checkmarks"
    >
      <div className="centerMaxWidthContainer">
        <div className="preContent preContent--0" data-mobile-align="mobileAlignAuto">
          <h2>{title}</h2>
        </div>
      </div>
      <div className="centerMaxWidthContainer">
        <ul className="grid iconList">
          {bulletPoints.map((bulletPoint) => (
            <li className="iconList-item" key={bulletPoint.title}>
              <p>
                <strong>{bulletPoint.title}</strong>:<br />
                {bulletPoint.body}
              </p>
            </li>
          ))}
        </ul>
        <div className="postContent-button">
          <CallToActionButton buttonText={buttonText} />
        </div>
      </div>
    </div>
  );
};

export default FeelgoodWeight;
